import cookies from 'js-cookie';
import { sanitizeId } from '../../../../config/ab/util';

// Fun Fact: https://en.wikipedia.org/wiki/Year_2038_problem
const DATE_MAX = new Date('2038-01-01');

export const SAW_AVAILABILITY_TOOLTIP_COOKIE = 'zd_saw_availability_tooltip';

/* Provider Availability Tooltip Cookie is used to ensure that
 *   a user only sees the tooltip once within the same session
 *   even if they browse away from Zocdoc and return.
 *
 *  Set this cookie when the user sees the tooltip
 */
export function maybeSetProviderAvailabilityTooltipCookie() {
    if (providerAvailabilityTooltipCookieMatchesBsid()) {
        return;
    }

    const bsidSession = sanitizeId(cookies.get('bsid'));
    cookies.set(
        SAW_AVAILABILITY_TOOLTIP_COOKIE,
        bsidSession,
        {
            expires: DATE_MAX,
        },
    );
}

/** Because the cookie is only sees this cookie when the tooltip is seen
 *      this check determines if the user saw the tooltip in the same session
 */
export function providerAvailabilityTooltipCookieMatchesBsid() {
    const cookie = cookies.get(SAW_AVAILABILITY_TOOLTIP_COOKIE);
    if (!cookie || !cookie.length) {
        return false;
    }

    const bsidSession = sanitizeId(cookies.get('bsid'));
    return bsidSession === cookie;
}
